/* Adds a "Copy" button to <pre> blocks in rich text (articles, pages) that copies the whole block. */
(function () {
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      document.body.removeChild(ta);
    });
  }

  function enhance(pre) {
    if (pre.closest('.tc-pre') || pre.closest('.tc-terminal')) return;
    var wrap = document.createElement('div');
    wrap.className = 'tc-pre';
    pre.parentNode.insertBefore(wrap, pre);
    wrap.appendChild(pre);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tc-pre__copy';
    btn.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/></svg><span>Copy</span>';
    btn.setAttribute('aria-label', 'Copy to clipboard');
    var status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('aria-live', 'polite');
    wrap.insertBefore(btn, pre);
    wrap.appendChild(status);

    var timer;
    btn.addEventListener('click', function () {
      var label = btn.querySelector('span');
      copyText(pre.innerText.replace(/\n$/, '')).then(function () {
        label.textContent = 'Copied';
        btn.classList.add('is-copied');
        status.textContent = 'Copied to clipboard';
      }, function () {
        label.textContent = 'Press Ctrl+C';
        var range = document.createRange();
        range.selectNodeContents(pre);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      });
      clearTimeout(timer);
      timer = setTimeout(function () {
        label.textContent = 'Copy';
        btn.classList.remove('is-copied');
        status.textContent = '';
      }, 2000);
    });
  }

  function init() {
    document.querySelectorAll('.rte pre, .tc-prose__body pre').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
